import React from "react";
import CollectionTitleCell from "collections/components/common/cells/CollectionTitleCell";
import SharedWithCell from "./cells/SharedWithCell";
const customColumnRenderers = {
  attributes: {
    title: {
      renderCell: (title, collection) => /* @__PURE__ */ React.createElement(CollectionTitleCell, { title, id: collection.id })
    },
    shared_with_users: {
      textAlign: "right",
      renderCell: (shared_with_users, collection) => /* @__PURE__ */ React.createElement(SharedWithCell, { shared_with: shared_with_users, id: collection.id, title: collection.title }),
      staticWidth: "matchHeader"
    },
    shared_with_teams: {
      textAlign: "right",
      renderCell: (shared_with_teams, collection) => /* @__PURE__ */ React.createElement(SharedWithCell, { shared_with: shared_with_teams, id: collection.id, title: collection.title }),
      staticWidth: "matchHeader"
    }
  }
};
export default customColumnRenderers;
